"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isProd;
function isProd(rootDomain) {
  return !rootDomain.includes('-');
}